import "./Home.module.css";
import TheEssenceHeader from "@/reusable_sections/Header";
import TheArtOfFragranceHero from "./sections/TheArtOfFragranceHero";
import TheSignatureCollections from "./sections/TheSignatureCollections";
import TheOlfactoryQuiz from "./sections/TheOlfactoryQuiz";
import ScentOfTheMonth from "./sections/ScentOfTheMonth";
import WhispersOfElegance from "./sections/WhispersOfElegance";
import TheBoutiqueFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <TheEssenceHeader />
      <TheArtOfFragranceHero />
      <TheSignatureCollections />
      <TheOlfactoryQuiz />
      <ScentOfTheMonth />
      <WhispersOfElegance />
      <TheBoutiqueFooter />
    </div>;
}